// extracted by mini-css-extract-plugin
export default {"modal":"approve-modal-mobile_modal__91mVB","fieldsSection":"approve-modal-mobile_fieldsSection__wtMBR"};